<template>
  <v-dialog
    :value="visible"
    max-width="30rem"
    persistent
    @input="close"
  >
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>{{ $t('pages.settings.users.deleteDialog.title') }}</v-card-title>

      <v-divider class="w-100" />

      <v-card-text class="pt-5">
        {{ $t('pages.settings.users.deleteDialog.subtitle') }}
      </v-card-text>

      <v-divider class="w-100" />

      <v-card-actions class="justify-end">
        <v-btn
          text
          :disabled="loading"
          @click="close"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="error"
          :elevation="0"
          @click="save"
        >
          {{ $t('pages.settings.users.deleteDialog.confirmButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogDeleteUser',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      validator: value => typeof value === 'object' || value === null,
      default: null
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    async save () {
      if (!this.user) return

      try {
        this.loading = true
        await this.$http.delete(`admin/settings/users/${this.user.id}`)
        this.$notify({ title: this.$t('success'), message: this.$t('pages.settings.users.deleteDialog.deletedSuccess'), type: 'success' })
        this.$emit('finished')
        this.close()
        this.loading = false
      } catch (error) {
        this.loading = false

        if (error.response && error.response.status === 403) {
          this.$notify({ title: this.$t('error'), message: this.$t('pages.settings.users.deleteDialog.cannotDelete'), type: 'error' })
          this.close()

          return
        }

        this.$notify({ title: this.$t('error'), message: this.$t('pages.settings.users.fetchFailed'), type: 'error' })
      }
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
